export const DEFAULT_VALUES = {
  firstName: '',
  lastName: '',
};
